import { AccreditationFormRepresentation } from './file-handling-utils.types';

export const getFileOrUrlPreview = (
  value: File | string | null | undefined,
  fallback: string | undefined
): { url: string | undefined; revoke?: () => void } => {
  if (typeof value === 'string' && value) {
    return { url: value };
  }
  if (value instanceof File) {
    const url = URL.createObjectURL(value);
    return {
      url,
      revoke:
        typeof URL.revokeObjectURL === 'function' ? () => URL.revokeObjectURL(url) : undefined,
    };
  }
  return { url: fallback };
};

export const addAccreditationFiles = (
  formData: FormData,
  accreditations?: AccreditationFormRepresentation[]
): void => {
  if (!accreditations) {
    return;
  }
  accreditations.forEach((accreditation) => {
    if (!accreditation.files) {
      return;
    }
    accreditation.files.forEach((file) => {
      formData.append(`${accreditation.id}-files[]`, file);
    });
  });
};

export const addFieldsToFormData = (
  formData: FormData,
  body: { [key: string]: string | Blob | number | undefined }
): void => {
  for (const key in body) {
    if (body[key] === undefined) {
      continue;
    }
    const value = body[key];
    formData.append(key, typeof value === 'number' ? value.toString() : (value as string | Blob));
  }
};
